import { Box, Button } from "@mui/material";
import HeaderSection from "./header-section";
import PriceSection from "./sections/price";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { useState } from "react";
import { setPrices } from "slices/searchListingReducer";

const PriceFilterSection = ({ onClose }: { onClose: any }) => {
  const { prices } = useAppSelector((state) => state.searchListingReducer);
  const [value, setValue] = useState(prices);
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ width: "600px" }}>
      <HeaderSection
        label="Price"
        showClearAll={false}
        disabledClearAll={true}
        onClose={onClose}
      />

      <PriceSection values={value} onChange={setValue} />

      <Box
        sx={{
          my: "15px",
          px: "4%",
          position: "absolute",
          width: "100%",
          right: 0,
          bottom: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            sx={{ height: "48px", borderRadius: "10px" }}
            variant="contained"
            onClick={() => {
              dispatch(
                setPrices([!value[0] ? 0 : value[0], !value[1] ? 0 : value[1]])
              );
              onClose();
            }}
          >
            Apply Filter
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PriceFilterSection;
